import { Reveal } from "@/components/site/motion";
import { Users, CheckSquare, CalendarClock, FileText, MessageSquare, GitBranch, BarChart3, Wallet, Download, Plug } from "lucide-react";

const CAPS = [
  { icon: Users, label: "View applicants" },
  { icon: CheckSquare, label: "Accept or reject applications" },
  { icon: CalendarClock, label: "Schedule interviews" },
  { icon: FileText, label: "Request documents" },
  { icon: MessageSquare, label: "Send automated messages" },
  { icon: GitBranch, label: "Track application pipeline" },
  { icon: BarChart3, label: "View recruitment analytics" },
  { icon: Wallet, label: "Manage commissions" },
  { icon: Download, label: "Export reports" },
  { icon: Plug, label: "API integrations" },
];

export const UniversityDashboard = () => (
  <section id="dashboard" data-testid="dashboard-section" className="relative bg-surface py-28 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="max-w-2xl">
          <Reveal><p className="text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">Built for Universities</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display font-extrabold tracking-tighter text-ink text-4xl sm:text-5xl leading-[0.98]">
              A dedicated university dashboard.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <span className="inline-flex items-center gap-2 rounded-full bg-cobalt/10 px-4 py-2 text-sm font-semibold text-cobalt">
            <span className="h-2 w-2 rounded-full bg-cobalt animate-pulse-ring" />
            Coming Soon
          </span>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {CAPS.map((c, i) => (
          <Reveal key={i} delay={(i % 5) * 0.05} className="rounded-2xl border border-slate-200 bg-white p-6" data-testid={`dashboard-cap-${i}`}>
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-cobalt/10">
              <c.icon className="h-5 w-5 text-cobalt" strokeWidth={1.75} />
            </div>
            <p className="mt-4 text-sm font-semibold text-ink leading-snug">{c.label}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
